module.exports = __webpack_public_path__ + "static/img/windows-tips.2a03d34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/windows-tips.png
// module id = 1311
// module chunks = 116